'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _siteOverlay$$siteOve; /*
                           
                             Declare and export all DOM strings here
                           
                             e.g.
                           
                             export default {
                               inlineCart: '[data-inline-cart]',
                               inlineCartContents: '[data-inline-cart-contents]',
                             };
                           
                             Usage:
                           
                             import dom from 'common/Dom';
                             import { getCartContents } from './handlers';
                           
                             $(dom.inlineCartContents).html(getCartContents());
                           
                           */


var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_siteOverlay$$siteOve = {
  //Overlay
  // FIX: change jquery cache variables to use their named variable instead of repeating the query string
  siteOverlay: '[data-site-overlay]',
  $siteOverlay: (0, _jquery2.default)('[data-site-overlay]'),
  hoverOverlay: '[data-hover-overlay]',
  $hoverOverlay: (0, _jquery2.default)('[data-hover-overlay]'),
  $html: (0, _jquery2.default)('html'),
  $body: (0, _jquery2.default)('body'),

  //Scroll
  scrollElement: '[data-scroll]',

  //Nav
  // FIX: add jquery cache variables as needed for these
  navDropdownTrigger: '[data-nav-dropdown-trigger]',
  navDropdown: '[data-nav-dropdown]',
  headerNav: '[data-header-nav]',
  mobileNavTrigger: '[data-mobile-nav-trigger]',
  mobileNav: '[data-mobile-nav]',

  //Header
  siteHeader: '[data-header]',
  siteSearch: '[data-search]',
  siteSearchContainer: '[data-header-search-container]',
  cartTotal: '[data-cart-count]',

  //Sticky Header
  stickyHeader: '[data-sticky-header]',
  stickySearch: '[data-sticky-search]',

  //Sliders
  heroSlider: '[data-hero-slider]',
  collectionSlider: '[data-collection-slider]',
  collectionSlide: '[data-collection-slide]',
  featureFilterSlider: '[data-feature-filter-slider]',
  featureFilterSlide: '[data-feature-filter-slide]',
  originalPosterSlider: '[data-original-poster-slider]',
  instagramSlider: '[data-instagram-slider]',

  //Feature Filter
  featureFilterContainer: '[data-feature-filter-container]',
  featureFilter: '[data-feature-filter]',
  featureFilterTrigger: '[data-feature-filter-trigger]',

  //Responsive
  responsiveImageSwap: '[data-responsive-image-swap]',

  //Glossary
  glossaryTerm: '[data-glossary-term]',
  glossaryTermTrigger: '[data-glossary-term-trigger]',
  glossaryAllTerms: '[data-glossary-all-terms]',
  glossaryAllTermsTrigger: '[data-glossary-all-terms-trigger]',

  //Original Poster Formating
  formatTerm: '[data-format-term]',
  formatTermTrigger: '[data-format-term-trigger]',

  //PDP
  atcPrice: '[data-add-to-cart-price]',
  productPrice: '[data-product-price]',
  comparePrice: '[data-product-compare-price]',
  printOption: '[data-print-option]',
  printButton: '[data-print-button]',
  finishBlocks: '[data-finish-block]',
  finishPanel: '[data-finish-panel]',
  finishRemove: '[data-finish-remove]',
  customFinishId: '[data-custom-finish-id]',
  customFinish: '[data-custom-finish]',
  customFinishPrice: '[data-custom-finish-price]',
  property: '[data-property]',
  selectize: '[data-selectize]',
  atcBtn: '[data-add-to-cart]',
  finishMoreOptionsTrigger: '[data-finish-more-trigger]',
  finishMoreOptions: '[data-finish-more]',
  finishAddon: '[data-finish-addon-product]',
  finishAddonTrigger: '[data-finish-addon-trigger]',
  customFinishAddon: '[data-custom-finish-addon]',
  customFinishAddonId: '[data-custom-finish-addon-id]',
  imdbDetails: '[data-imdb-details]',
  imdbDescription: '[data-imdb-description]',
  imdbDirector: '[data-imdb-director]',
  imdbWriters: '[data-imdb-writers]',
  imdbActors: '[data-imdb-actors]',
  imdbYear: '[data-imdb-year]',

  //Login Forms
  loginForm: '[data-login]',
  recoverForm: '[data-recover-password]',
  recoverFormTrigger: '[data-recover-password-trigger]',
  resetSuccessMessage: '[data-reset-success]',
  resetSuccessTrigger: '[data-reset-success-trigger]',

  //Address Forms
  addressTrigger: '[data-address-trigger]',
  addressForm: '[data-address-form]',
  addressCancelTrigger: '[data-address-cancel-trigger]',
  countrySelector: '[data-address-country]',
  provinceSelector: '[data-address-province]',
  deleteForm: '[data-address-delete-form]',

  //Cart
  cartContainer: '[data-cart-container]',
  lineItem: '[data-line-item]',
  lineItemRemoveTrigger: '[data-line-item-remove-trigger]',
  lineItemProperty: '[data-line-item-property]',
  lineItemCustomFinishId: '[data-line-item-custom-finish-id]',
  customFinishLineItem: '[data-line-item-custom-finish-product]',
  cartSummarySubtotal: '[data-summary-subtotal]',
  cartSummaryTotal: '[data-summary-total]',

  //QTY
  qty: '[data-quantity]',
  qtyAdjust: '[data-quantity-adjust]',
  qtyInput: '[data-quantity-input]',

  //Cart addon
  addon: '[data-addon]',
  addonTrigger: '[data-addon-trigger]',
  addonItemTrigger: '[data-addon-item-trigger]',
  addonLineItem: '[data-addon-line-item]',
  addonEditTrigger: '[data-addon-edit-trigger]',
  addonRemoveTrigger: '[data-addon-remove-trigger]',
  addonQty: '[data-quantity-addon]',
  addonQtyAdjust: '[data-quantity-adjust-addon]',
  addonQtyInput: '[data-quantity-input-addon]',

  //Quickview
  quickviewContainer: '[data-quickview-container]',
  quickview: '[data-quickview]',
  quickviewForm: '[data-quickview-form]',

  //Collection Item
  product: '[data-product]',
  productForm: '[data-product-form]',
  productVariant: '[data-product-selected-variant]',
  productMeta: '[data-product-meta]',
  productDimensions: '[data-product-dimensions]',

  //Cart Popup
  cartPopup: '[data-cart-popup]',
  cartPopupCloseTrigger: '[data-cart-popup-close-trigger]',
  cartPopupLink: '[data-cart-popup-cart-link]',
  cartPopupImage: '[data-cart-popup-image]',
  cartPopupTitle: '[data-cart-popup-title]',
  cartPopupPrice: '[data-cart-popup-price]',
  cartPopupFinish: '[data-cart-popup-finish]',
  cartPopupTags: '[data-cart-popup-tags]',
  cartPopupDimensions: '[data-cart-popup-dimensions]',
  cartPopupCount: '[data-cart-popup-count]'
}, (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'cartPopupFinish', '[data-cart-popup-finish]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'collectionFilterToggle', '[data-filter-toggle]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'collectionFilters', '[data-collection-filters]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'collectionContent', '[data-collection-content]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'collectionHeader', '[data-collection-header]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'collectionSortingToggle', '[data-collection-sorting-toggle]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'collectionSorting', '[data-collection-sorting]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'paginateInput', '[data-pagination-input]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'customFrameInput', '[data-custom-frame-input]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'customFrameWidth', '[data-custom-frame-width]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'customFrameHeight', '[data-custom-frame-height]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'customFrame', '[data-custom-frame]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'customFrameCloseTrigger', '[data-custom-frame-close-trigger]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'frameTrigger', '[data-frame-trigger]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'frameDropdown', '[data-frame-dropdown]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'customFrameSizeTrigger', '[data-custom-frame-size-trigger]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'frameSizeTrigger', '[data-frame-size-trigger]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'frameRange', '[data-frame-range]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'customFrameError', '[data-custom-frame-error]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'frameFeatureImage', '[data-frame-image]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'frameFinish', '[data-frame-finish-select]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'rewardsDetails', '[data-rewards-details]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'rewardsDetailsTrigger', '[data-rewards-details-trigger]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'sizeDropdownTrigger', '[data-size-dropdown-trigger]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'sizeDropdown', '[data-size-dropdown]'), (0, _defineProperty3.default)(_siteOverlay$$siteOve, 'optionTrigger', '[data-option-trigger]'), _siteOverlay$$siteOve);